query (
  $filter: MarketFavoriteFilter,
) {
    marketGroups: allMarketGroups(
        orderBy: POSITION_ASC
    ) {
        nodes {
            active
            code
            displayName
            position
            sportId
            marketCodes: marketGroupMarketCodesByMarketGroupId {
                nodes {
                    marketCode
                }
            }
        }
    }
    allMarketFavorites(
        filter: $filter
    ) {
        nodes {
            code
        }
    }
}
